import { IconProps } from './types';

export default function Video({ className, strokeWidth }: IconProps) {
    return (
        <svg
            fill="none"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            role="img"
            className={className}
            strokeWidth={strokeWidth}
        >
            <g
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="m4.57143 7h9.14287c.6062 0 1.1876.24082 1.6162.66947.4287.42865.6695 1.01004.6695 1.61624v6.85719c0 .1515-.0602.2969-.1674.404-.1071.1072-.2525.1674-.404.1674h-9.14289c-.6062 0-1.18759-.2408-1.61624-.6695-.42865-.4286-.66947-1.01-.66947-1.6162v-6.85717c0-.15155.0602-.2969.16737-.40406.10716-.10717.25251-.16737.40406-.16737z" />
                <path d="m16 10.7144 4-2.28569v6.85719l-4-2.2858" />
            </g>
        </svg>
    );
}
